import { Link } from "react-router-dom";

interface ShowCardProps {
  id: number;
  title: string;
  category: string;
  imageUrl: string;
  rating: number;
  updateInfo: string;
  views: string;
  showCategory?: boolean;
}

export default function ShowCard({
  id,
  title,
  category,
  imageUrl,
  rating,
  updateInfo,
  views,
  showCategory = true,
}: ShowCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 红桃影院综艺在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-background-900/70 backdrop-blur-sm text-accent-400 text-xs font-medium rounded-md">
            <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
            {rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-3">
          <span className="text-background-50 text-xs font-medium">{updateInfo}</span>
        </div>
      </div>
      <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-400">
        {showCategory && <span>{category}</span>}
        <span className="flex items-center gap-1">
          <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
          {views}
        </span>
      </div>
    </Link>
  );
}